import { render, staticRenderFns } from "./PhoneStep.vue?vue&type=template&id=74f91dc9&"
import script from "./PhoneStep.vue?vue&type=script&lang=js&"
export * from "./PhoneStep.vue?vue&type=script&lang=js&"
import style0 from "./PhoneStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VTextField})
